(function () {
    'use strict';

    angular.module("imApp").factory("categoryLinksService", ['$ihttp', function ($ihttp) {
        let service = {
            getBelongTo: function (parms) {
                return $ihttp.post({
                    method: 630,
                    parameters: parms || {}
                });
            },
            getCategoryLink: function (parms) {
                return $ihttp.post({
                    method: 634,
                    parameters: parms || {}
                });
            },
            listCategoryLinks: function (parms) {
                return $ihttp.post({
                    method: 629,
                    parameters: parms || {}
                });
            },
            listLanguages: function (parms) {
                return $ihttp.post({
                    method: 704,
                    parameters: parms || {}
                });
            },
            updateCategory: function (edit) {
                return $ihttp.post({
                    method: 637,
                    parameters: edit
                });
            },
            saveItems: function (list) {
                return $ihttp.post({
                    method: 705,
                    parameters: list
                });
            },
            deleteLink: function (edit) {
                return $ihttp.post({
                    method: 633,
                    parameters: edit
                });
            },
            deleteCategory: function (edit) {
                return $ihttp.post({
                    method: 635,
                    parameters: edit
                });
            }
        };

        return service;
    }]);
})();
